import { type MCPServerInfo } from '../../types';

export const CloudflareAuditLogsServer: MCPServerInfo = {
  serverId: 'CLOUDFLARE_AUDIT_LOGS',
  name: 'Cloudflare Audit Logs',
  slug: 'cloudflare-audit-logs',
  description: 'Cloudflare Audit Logs MCP Server',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://auditlogs.mcp.cloudflare.com/mcp',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export const CloudflareWorkersObservabilityServer: MCPServerInfo = {
  serverId: 'CLOUDFLARE_WORKERS_OBSERVABILITY',
  name: 'Cloudflare Workers Observability',
  slug: 'cloudflare-workers-observability',
  description: 'Cloudflare Workers Observability MCP Server',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://observability.mcp.cloudflare.com/mcp',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};
